// i18n configuration for CourtMate Web
// Created by Taulant Geci

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './en.json';
import deTranslations from './de.json';

const resources = {
  en: {
    translation: enTranslations
  },
  de: {
    translation: deTranslations
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de', // default language changed to German
    fallbackLng: 'de', // fallback to German instead of English
    
    interpolation: {
      escapeValue: false // React already does escaping
    }
  });

export default i18n; 